module.exports = __webpack_public_path__ + "img/ar_hash_down_g.226c5524.svg";